import { FormSubmissionDto, FormTwoExternalIdWithStringItemType, IFormSubmissionDto, IPmsSystemVm } from '../api/web-api-client';
import { Contact } from '../hooks/use-rw-platform-client.interface';

export interface IFormsService {
    getFormJson(id: string | undefined, unwrapperedDomain: string): Promise<unknown[]>;
    getLegacyFormJson(id: string | undefined, unwrapperedDomain: string): Promise<FormJsonData>;
    convertTruFormJsonToJsonSchema(json: string): FormJsonData;
}


export interface ILayoutRule {
    sourceId: string,
    targetId: string,
    condition: string,
    value: string
}

export interface FormJsonData {
    pdf?: any;
    layout?: ILayoutRow[],
    components?: Map<string, IComponent>;
    rules?: Rule[];
    displayLabels?: boolean;
}

export interface SubmissionPdfViewProps {
    selectedSubmission?: IFormSubmissionDto,
    submissionJson?: ISubmissionJsonField[],
    formJson: FormJsonData
}

export interface FormSubmissionDtoWithJson extends FormSubmissionDto {
    formJson: FormJsonData,
}

export interface ILayoutRow {
    type: string,
    id: string,
    title?: string,
    children?: ILayoutColumn[]
    visible?: boolean
    practice?: boolean
}

export interface ILayoutColumn {
    type: string,
    id: string,
    title?: string,
    children?: ILayoutComponent[]
}

export interface ILayoutComponent {
    type: string,
    id: string,
    name?: string,
}

export default interface IComponent {
    name: string;
    type: string;
    field_name?: string;
    fieldId?: number;
    externalId?: FormTwoExternalIdWithStringItemType;
    label?: string;
    id?: string;
    handleChange?: any;
    defaultValue?: string;
    disabled?: boolean;
    read_only?: string;
    mutable?: boolean;
    ref?: any;
    error?: any;
    canHaveOptionCorrect?: boolean;
    canHaveOptionValue?: boolean;
    dirty?: boolean;
    element?: string;
    options?: IPropsDataOptions[]
    optionsSource?: OptionsSource;
    required?: boolean;
    text?: string;
    mask?: string;
    defaultToday?: boolean;
    dateFormat?: string;
    showTimeSelect?: boolean;
    showTimeSelectOnly?: boolean;
    timeFormat?: string;
    content?: string;
    childComponents?: Map<string, IComponent>;
    isMobile?: boolean;
    explaination?: boolean;
    googleMapApiKey?: string;
    key?: string;
    medications?: string[];
    typeDisplay?: string;
    editMode?: boolean;
    selected?: boolean;
    value?: string;
    canDefaultToday?: boolean;
    canReadOnly?: boolean;
    canHaveAnswer?: boolean;
    static?: boolean;
    title?: string;
    description?: string;
    autocomplete?: string;
    practice?: boolean;
    displayLabel?: boolean;
    pmsSystemVm?: IPmsSystemVm;
}

export enum OptionsSource {
    MANUAL = 0,
    INSURANCEPROVIDER = 1,
}

export interface IPropsDataOptions {
    key: string;
    value: string;
    text: string;
}

export interface ISubmissionJsonDataEdit {
    originalFormValue: unknown,
    currentValueSource: ValueSource
}

export interface ISubmissionJsonDataNetworkField {
    label: string,
    type: string
}

export enum ValueSource {
    Form = 0,
    PMS
}

export interface ISubmissionJsonField {
    id: string,
    value: unknown,
    fieldId?: number,
    externalId?: FormTwoExternalIdWithStringItemType,
    edit?: ISubmissionJsonDataEdit
}

export interface ISubmissionAuditFieldValue {
    user: string,
    date: string
}


export interface IDataCompareRow {
    field: ISubmissionJsonField,
    fieldName: string,
    valueInPms?: unknown,
    getContactValue: (c: Contact) => unknown,
    formValueFormatter?: (v: unknown) => unknown
}

export interface Rule {
    sourceId: string,
    targetId: string,
    condition: string,
    value: string
}






